!function ($, global) {
    'use strict';

    var document = global.document;

    var $window = $(global);
    var $document = $(document);
    var $body = $(document.body);
    var $wrapper = $('.navbar-wrapper');
    var $navbar = $('nav.navbar');
    var ACTIVE_EVENT = 'navbar-wrapper-active';

    var offsetTop = $wrapper.length ? $body.offset().top - $wrapper.offset().top : 0;

    var $wrapperStylesheet = {
        'd': $('<style>').appendTo('head'), // desktop
        'm': $('<style>').appendTo('head')	// mobile
    };

    var isOverlay = {
        'd': $navbar.hasClass('navbar-overlay'),
        'm': $navbar.hasClass('navbar-mobile-overlay')
    };

    var isSticky = {
        'd': $navbar.hasClass('navbar-sticky'),
        'm': $navbar.hasClass('navbar-mobile-sticky')
    };

    var whichTransitionEvent = function () {
        var element = document.createElement('a');
        var transitions = {
            'transition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        };
        var property;

        for (property in transitions) {
            if (element.style[property] !== undefined) {
                return transitions[property];
            }
        }
    };

    var transitionEvent = whichTransitionEvent();

    var DEFAULTS = {
        classes: []
    };

    var primary = $.extend({}, DEFAULTS, $navbar.data('omtNavbarPrimary'));
    var secondary = function () {
        var secondary = $.extend({}, DEFAULTS, $navbar.data('omtNavbarSecondary'));
        var matches;
        var value;

        if(secondary.top && (matches = secondary.top.match(/^(-?\d+|-?\d*\.\d+)(\w+)?$/))) {
            matches = secondary.top.match(/^(-?\d+|-?\d*\.\d+)(\w+)?$/);
            value = parseFloat(matches[1]) || 0;

            if (matches[2] === 'vh') {
                secondary.topPercent = value / 100;
            } else if (matches[2] === 'rem') {
                secondary.topValue = value * parseInt(getComputedStyle(document.body).fontSize);
            } else {
                secondary.topValue = value;
            }
        } else {
            secondary.topValue = 0;
        }

        return secondary;
    }();

    var mobileBreakpoint = 991;
    var isDesktop = global.innerWidth > mobileBreakpoint;

    var saveNavbarHeight = function (event) {
        if (!event || event.target === $navbar[0]) {
            if (isDesktop) {
                if ($navbar.hasClass('navbar-primary')) {
                    if (!$navbar.data('primaryHeight')) {
                        $navbar.data('primaryHeight', $navbar.outerHeight());
                        setWrapperHeight($navbar.data('primaryHeight'), 'd');
                    }
                } else if ($navbar.hasClass('navbar-secondary')) {
                    if (!$navbar.data('secondaryHeight')) {
                        $navbar.data('secondaryHeight', $navbar.outerHeight());
                    }
                }
            } else {
                if (!$navbar.data('mobileHeight')) {
                    $navbar.data('mobileHeight', $navbar.outerHeight());
                    setWrapperHeight($navbar.data('mobileHeight'), 'm');
                }
            }
        }
    };

    $navbar.on(transitionEvent, saveNavbarHeight);

    var getMode = function () {
        return global.innerWidth > mobileBreakpoint ? 'd' : 'm';
    };

    // WRAPPER INIT
    // ============

    var checkWrapper = function (resizeEvent) {
        var mediaRule;
        var activeClass;
        var stickyClass;
        var overlayClass;
        var mode = getMode();

        isDesktop = mode === 'd';

        if (isDesktop) {
            activeClass = 'wrapper-active';
            stickyClass = 'navbar-sticky';
            overlayClass = 'navbar-overlay';
        } else {
            activeClass = 'wrapper-active-mobile';
            stickyClass = 'navbar-mobile-sticky';
            overlayClass = 'navbar-mobile-overlay';
        }

        if (!$wrapper.hasClass(activeClass)) {
            if ($navbar.hasClass(stickyClass) && !isOverlay[mode]) {
                var height = isDesktop
                    ? $navbar.data('primaryHeight') || $navbar.outerHeight()
                    : $navbar.data('mobileHeight') || $navbar.outerHeight();

                setWrapperHeight(height, mode);
            }

            $wrapper.addClass(activeClass);
            $document.trigger(ACTIVE_EVENT);
        }
    };

    var setWrapperHeight = function (height, mode) {
        if (isOverlay[mode]) {
            return;
        }

        var css = '';
        var mediaRule = '';

        var isDesktop = mode === 'd';

        if (isDesktop) {
            mediaRule = 'min-width: ' + (mobileBreakpoint + 1) + 'px';
        } else {
            mediaRule = 'max-width: ' + mobileBreakpoint + 'px';
        }

        if (mode === 'd') {
            css = '@media(' + mediaRule + ') {.navbar-wrapper {min-height:' + height + 'px;}}';
        } else if (mode === 'm') {
            css = '@media(' + mediaRule + ') {.navbar-wrapper {min-height:' + height + 'px;}}';
        }

        if ($wrapperStylesheet[mode]) {
            $wrapperStylesheet[mode].text(css);
        }
    };


    // MODE
    // ====
    if ($navbar.hasClass('navbar-use-secondary')) {
        var setModeFn = function (addData, removeData) {
            var addClasses = addData.classes.join(' ');
            var removeClasses = $(removeData.classes).not(addData.classes).get().join(' ');

            return function () {
                $navbar.addClass(addClasses).removeClass(removeClasses);
            };
        };

        var setPrimaryMode = setModeFn(primary, secondary);
        var setSecondaryMode = setModeFn(secondary, primary);

        $window.on('scrolled.om', function (event, data) {
            var top = data.top + offsetTop;
            var secondaryTop = secondary.topPercent !== undefined ? secondary.topPercent * data.window : secondary.topValue;

            if (data.direction > 0) {
                if (top > secondaryTop) {
                    setSecondaryMode();
                    $navbar.removeClass('navbar-primary-hidden');
                } else if (secondary.veiled && primary.static && top > $navbar.data('primaryHeight')) {
                    $navbar.addClass('navbar-primary-hidden');
                }

                if (secondary.veiled) {
                    $navbar.addClass('navbar-secondary-hidden');
                }
            } else {
                if (primary.static) {
                    if (top <= offsetTop) {
                        setPrimaryMode();
                        $navbar.removeClass('navbar-primary-hidden');
                    }
                    if (secondary.veiled && top <= $navbar.data('primaryHeight')) {
                        $navbar.removeClass('navbar-primary-hidden');
                    }
                } else {
                    if (top <= secondaryTop) {
                        setPrimaryMode();
                    }
                }

                if (secondary.veiled) {
                    $navbar.removeClass('navbar-secondary-hidden');
                }
            }

        });

        saveNavbarHeight(); // save navbar ready size on page init
    }

    if ($wrapper.length && $navbar.length) {
        $window.resize(checkWrapper);
        checkWrapper();
    }


    // Extra classes
    // =============

    var COLLAPSE_HIDDEN_CLASS = 'collapse-hidden';
    var COLLAPSE_HIDE_CLASS = 'collapse-hide';
    var COLLAPSE_SHOWN_CLASS = 'collapse-shown';
    var COLLAPSE_SHOW_CLASS = 'collapse-show';
    var COLLAPSE_ALL_CLASSES = [COLLAPSE_HIDDEN_CLASS, COLLAPSE_HIDE_CLASS, COLLAPSE_SHOWN_CLASS, COLLAPSE_SHOW_CLASS];

    var getCollapseHandler = function ($element, stateClass) {
        var toRemove = $(COLLAPSE_ALL_CLASSES).not([stateClass]).get().join(' ');

        return function () {
            $element.addClass(stateClass).removeClass(toRemove);
        }
    };

    $navbar.on('hidden.bs.collapse', getCollapseHandler($navbar, COLLAPSE_HIDDEN_CLASS));
    $navbar.on('hide.bs.collapse', getCollapseHandler($navbar, COLLAPSE_HIDE_CLASS));
    $navbar.on('show.bs.collapse', getCollapseHandler($navbar, COLLAPSE_SHOW_CLASS));
    $navbar.on('shown.bs.collapse', getCollapseHandler($navbar, COLLAPSE_SHOWN_CLASS));

}(jQuery, window);
